
      var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCarouselArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 104,
  height: 104,
  viewBox: "0 0 52 52",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#carousel-arrow-left_a4c20cf770f8f7fb__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 26,
  r: 16,
  fill: "var(--theme-light, #f9f3fb)"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M28.198 30.54c.258.26.27.697.029.975a.607.607 0 0 1-.843.087l-.062-.055-5.12-5.177a.73.73 0 0 1-.054-.946l.054-.06 5.12-5.177a.608.608 0 0 1 .905.031.733.733 0 0 1 .026.913l-.055.063-4.622 4.673 4.622 4.673z",
  fill: "var(--theme-primary, #810ea9)",
  stroke: "var(--theme-primary, #810ea9)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "carousel-arrow-left_a4c20cf770f8f7fb__a",
  x: 0,
  y: 0,
  width: 52,
  height: 52,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.170837 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_266"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1_266",
  result: "shape"
})))));

      const __svgRaw = "<svg width=\"104\" height=\"104\" viewBox=\"0 0 52 52\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <g filter=\"url(#dk3w48epya)\">\r\n        <circle cx=\"26\" cy=\"26\" r=\"16\" fill=\"var(--theme-light, #f9f3fb)\"/>\r\n    </g>\r\n    <path d=\"M28.198 30.54c.258.26.27.697.029.975a.607.607 0 0 1-.843.087l-.062-.055-5.12-5.177a.73.73 0 0 1-.054-.946l.054-.06 5.12-5.177a.608.608 0 0 1 .905.031c.223.257.229.649.026.913l-.055.063-4.622 4.673 4.622 4.673z\" fill=\"var(--theme-primary, #810ea9)\" stroke=\"var(--theme-primary, #810ea9)\"/>\r\n    <defs>\r\n        <filter id=\"dk3w48epya\" x=\"0\" y=\"0\" width=\"52\" height=\"52\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\r\n            <feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\r\n            <feColorMatrix in=\"SourceAlpha\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\r\n            <feOffset/>\r\n            <feGaussianBlur stdDeviation=\"5\"/>\r\n            <feColorMatrix values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.170837 0\"/>\r\n            <feBlend in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_1_266\"/>\r\n            <feBlend in=\"SourceGraphic\" in2=\"effect1_dropShadow_1_266\" result=\"shape\"/>\r\n        </filter>\r\n    </defs>\r\n\r\n \r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/carousel-arrow-left.a4c20cf770f8f7fb76ce75c76fd4d76b.svg"),
        {
          React: SvgCarouselArrowLeft,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      